export const environment = {
  production: true,
  supabaseUrl: 'https://mofwhktflyudfqszwmct.supabase.co',
  supabaseKey:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Im1vZndoa3RmbHl1ZGZxc3p3bWN0Iiwicm9sZSI6ImFub24iLCJpYXQiOjE2NzgwMjgyNDQsImV4cCI6MTk5MzYwNDI0NH0.gP4sYBVywAYR9QOVZi4RlU_dToZQkcOs0TpPLYJ_MO8',
  tsKey: 'Z3Qp7sUlJHXTl1i4zyZ4ccLf7azzD2Qh',
  typesenseUrl: '8sxu7ftwzrebhmg3p-1.a1.typesense.net',
  graphApiUrl: 'https://graph-api.placeholder.example',
  country: 'EE' as const,
  // Injected by AnalyticsLoaderService only after analytics consent is granted.
  // There is deliberately no gtag snippet in index.ee.html.
  gaMeasurementId: 'G-ZNM9KP1Q2F',
  gtmContainerId: '',
};
